import React from 'react';
import useAuthContext from '../../contexts/AuthContext';
import SimpleResourceLandingLayout from '../../components/layouts/SimpleResourceLandingLayout';
import columns from './columns';

const Unpaid = () => {
  const { user, checkRightMenuAccess } = useAuthContext();

  return (
    <SimpleResourceLandingLayout
      withCreateButton={false}
      resourceName="contracts"
      extraQuery={`status=UNPAID_1,UNPAID_2,UNPAID_3,FORMAL_NOTICE,WARRANTY_SUSPENSION&!previous_contract${
        checkRightMenuAccess('contracts') ? '' : `&user=${user?._id}`
      }`}
      populate="insurer"
      columns={columns()}
      editAction={false}
      deleteAction={false}
    />
  );
};

export default Unpaid;
